import Theme from 'Theme';
import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';
import type { StylesMap } from 'Types';
import type { InfoListProps } from './InfoList';

type StylesProps = {
    isSingleColumn?: InfoListProps['isSingleColumn'];
    isPlayerInfo?: InfoListProps['isPlayerInfo'];
};

const getStyles = ({ isSingleColumn, isPlayerInfo }: StylesProps = {}): StylesMap => {
    let styles: StylesMap = {
        container: {
            flex: 1,
            alignSelf: 'stretch',
            width: '100%',
            height: '100%'
        },
        itemContainer: {
            alignSelf: 'stretch',
            flexDirection: 'column',
            marginBottom: 20
        },
        itemLabel: {
            fontFamily: Theme.regularFont,
            color: Theme.secondaryTextColor,
            fontSize: Theme.fontSizes.description,
            width: '100%',
            lineHeight: 28
        },
        itemValues: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            marginLeft: 0
        }
    };

    if (Device.isTabletOrWeb)
        styles = {
            ...styles,
            itemContainer: {
                ...styles.itemContainer,
                flexDirection: isSingleColumn ? 'column' : 'row'
            },
            itemLabel: {
                ...styles.itemLabel,
                width: isSingleColumn ? '100%' : '20%'
            },
            itemValues: {
                ...styles.itemValues,
                width: isSingleColumn ? '100%' : '75%',
                marginLeft: isSingleColumn ? 0 : 15
            }
        };

    return StyleSheet.create(styles);
};

export default getStyles;
